<template>
	<img
		:src="src_l"
		:alt="alt"
		:class="cls_l"
	/>
</template>

<script>

export default {
	
	props: [
		'tsrc',
		'src',
		'alt',
		'cls'
	],

	data(){ return {
			
		src_l: undefined,

	}},

	computed:{

		cls_l(){
			return this.cls
		},

	},

	methods: {

		loadImg(){
			
			var _this = this
			var src = this.src

			var newImg = new Image
			newImg.onload = () => {
				_this.src_l = _this.src
			}

			newImg.src = this.src

		},		

	},

	created(){

		this.src_l = this.tsrc
		this.loadImg()

	},

}
</script>



// WEBPACK FOOTER //
// src/components/ImgLazy.vue